__turbopack_context__.v({
  "all": "mega-menu-module__xqhPra__all",
  "cat": "mega-menu-module__xqhPra__cat",
  "catSelected": "mega-menu-module__xqhPra__catSelected",
  "cats": "mega-menu-module__xqhPra__cats",
  "expanded": "mega-menu-module__xqhPra__expanded",
  "heading": "mega-menu-module__xqhPra__heading",
  "headingLink": "mega-menu-module__xqhPra__headingLink",
  "intro": "mega-menu-module__xqhPra__intro",
  "item": "mega-menu-module__xqhPra__item",
  "label": "mega-menu-module__xqhPra__label",
  "left": "mega-menu-module__xqhPra__left",
  "list": "mega-menu-module__xqhPra__list",
  "main": "mega-menu-module__xqhPra__main",
  "nav": "mega-menu-module__xqhPra__nav",
  "panel": "mega-menu-module__xqhPra__panel",
  "panel-in": "mega-menu-module__xqhPra__panel-in",
  "panelInner": "mega-menu-module__xqhPra__panelInner",
  "right": "mega-menu-module__xqhPra__right",
  "root": "mega-menu-module__xqhPra__root",
  "row": "mega-menu-module__xqhPra__row",
  "rowArrow": "mega-menu-module__xqhPra__rowArrow",
  "rowDesc": "mega-menu-module__xqhPra__rowDesc",
  "rowIcon": "mega-menu-module__xqhPra__rowIcon",
  "rowItem": "mega-menu-module__xqhPra__rowItem",
  "rowName": "mega-menu-module__xqhPra__rowName",
  "rowText": "mega-menu-module__xqhPra__rowText",
  "rows": "mega-menu-module__xqhPra__rows",
  "scrim": "mega-menu-module__xqhPra__scrim",
  "strip": "mega-menu-module__xqhPra__strip",
  "stripLabel": "mega-menu-module__xqhPra__stripLabel",
  "stripLink": "mega-menu-module__xqhPra__stripLink",
  "stripLinks": "mega-menu-module__xqhPra__stripLinks",
  "tag": "mega-menu-module__xqhPra__tag",
});
